import { useCallback } from "react";
import { CacheKey, ICache } from "../helpers/utils/cache.util";
import cache from "../states/cache-state/cache";

function useCache(defaultTimeToLive = 300) {
  const fetchWithCache = useCallback(
    async <T,>(
      key: CacheKey,
      fn: () => Promise<T>,
      timeToLive = defaultTimeToLive,
    ): Promise<T> => {
      const cacheData = cache.get<T>(key);
      if (cacheData) {
        return Promise.resolve(cacheData);
      }
      return fn().then((data) => {
        cache.set(key, data, timeToLive);
        return data;
      });
    },
    [defaultTimeToLive],
  );

  const invalidate = useCallback((key: CacheKey) => {
    cache.delete(key);
  }, []);

  return {
    cache: cache as Readonly<ICache>,
    fetchWithCache,
    invalidate,
  };
}

export default useCache;
